import { MOBILE_BREAKPOINT, SMALL_BREAKPOINT } from '../contexts/DeviceContext';

export class DeviceDetecor {

	public static isTouch(): boolean {
		const navigator = window.navigator as any;
		return ('ontouchstart' in window) ||
			(navigator.maxTouchPoints > 0) ||
			(navigator.msMaxTouchPoints > 0);
	}

	public static isMobile() {
		return this.isTouch() && window.innerWidth < MOBILE_BREAKPOINT;
	}

	public static isSmall() {
		return window.innerWidth < SMALL_BREAKPOINT;
	}

	public static scrollWidth() {
		const testWidth = 100;
		const test1 = document.createElement('div');
		document.body.append(test1);
		test1.style.overflow = 'scroll';
		test1.style.width = testWidth + 'px';
		const test2 = document.createElement('div');
		test1.append(test2);
		let scrollWidth = testWidth - test2.offsetWidth;
		test1.remove();
		return scrollWidth;
	}
}
